module.exports = __webpack_public_path__ + "assets/images/project/japanese-cemetery/03.jpg?v=1ea112cd";